<template>
  <div class="mian">
    <div>
      <Nav :title="navTitle"></Nav>
    </div>
    <van-cell :title="cyrrentDate" :value="text" />
    <div class="cellBorder"></div>
    <ul class="weekdays">
      <li>周一</li>
      <li>周二</li>
      <li>周三</li>
      <li>周四</li>
      <li>周五</li>
      <li>周六</li>
      <li>周日</li>
    </ul>
    <div class="cellBorder"></div>
    <ul class="days">
      <li @click="pick(day, $event)" v-for="(day, index) in days" :key="index">
        <!-- 判断是否是明天 -->
        <span v-if="isTomorrow(day)" class="active">明天</span>
        <!--不是本月-->
        <span
          v-else-if="day.getMonth() != new Date().getMonth()"
          class="other-month"
          >{{ day.getDate() }}</span
        >

        <span v-else>{{ day.getDate() }}</span>
      </li>
    </ul>
    <!-- 排班医生显示 -->
    <div class="duty">
      <div v-for="(item, index) in doctorList" :key="index" class="dutyIcon">
        <div class="doctor">
          <img src="../../assets/dutyImg/doctor.png" class="doctorImg" />
          <div style="doctorIcon">
            <div style="display: flex">
              <span class="doctorName">{{ item.name }}</span>
              <span class="doctorTitlt">{{ item.title }}</span>
            </div>
            <div class="timeIcon">
              <img src="../../assets/dutyImg/time.png" class="timeImg" />
              <span style="font-size: 14px"
                >{{ parseInt(item.time.substr(0, 2)) > 12 ? "下午" : "上午" }}
                {{ item.time }}</span
              >
            </div>
          </div>
        </div>

        <hr class="separate" />
        <div class="icon">
          <img src="../../assets/dutyImg/icon.png" width="20px" height="20px" />
          <span class="icon-text">余号：{{ item.surplus }}</span>
          <span class="icon-text">金额：￥{{ item.money }}元</span>
          <van-icon name="arrow" size="25px" style="margin-left: auto" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon } from "vant";
import { Toast } from "vant";

Vue.use(Toast);
Vue.use(Icon);

import Nav from "../../components/nav.vue";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      navTitle: "内科",
      cyrrentDate: new Date().toISOString().slice(0, 10),
      text: "按日期预约",
      days: [],
      doctorList: [{
          name: "何亚妮",
          title: "副主任医师",
          time: "08:00-11:30",
          money: "10.5",
          surplus: 47,
        },
        {
          name: "何妮",
          title: "副主任医师",
          time: "08:00-11:30",
          money: "10.5",
          surplus: 47,
        },],
    };
  },
  created() {
    this.navTitle = this.$route.query.data;
    this.initData();
  },

  methods: {
    //初始化时间
    initData() {
      var date = new Date();
      //获取今天星期几
      var week = date.getDay();
      //获取这个月第几天
       var day = date.getDate();
      var weekArray = [];
      //确定未来七天的日期
      for (var index = week; index - week < 7; index++) {
        //构造日期对象 new Date(year, month + 1, 0)
        //如若日期溢出，则会自动更换月份，年份
        //因为是预约挂号，因此从明天开始
        weekArray[index % 7] = new Date(
          date.getFullYear(),
          date.getMonth(),
          day + index - week + 1
        );
      }
      this.days = weekArray;
    },

    //请求医生排班信息，参数为被请求日期的Date对象
    inquiryDuty(data) {
      this.doctorList = [];
      //消息提示框，提示正在加载某一天的医生信息
      Toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true,
      });

      //网络请求代码

      // //手动清除加载提示框
      // Toast.clear();
      // //提示没有排班信息
      // Toast("暂无排班");
      // //提示查询过程失败
      // Toast.fail("请求失败");
    },

    //判断是否为明天，且在此初始化医生排班信息
    isTomorrow(date) {
      var now = new Date();
      var tomorrow = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1
      );

      if (date.getTime() == tomorrow.getTime()) {
        //初始化排班信息
        //this.inquiryDuty(date);
        return true;
      }
      return false;
    },

    // 当前选择日期
    pick(date, e) {
      /*  alert(
        this.formatDate(date.getFullYear(), date.getMonth() + 1, date.getDate())
      ); */
      //切换日期选中状态
      var parentNode = e.currentTarget.parentNode;
      //移除被选中状态
      parentNode.children.forEach((element) => {
        element.firstChild.classList.remove("active");
      });
      //赋予被选中状态
      e.currentTarget.firstChild.classList.add("active");

      //以下为请求排班信息
      //inquiryDuty(date);
    },

    formatDate(year, month, day) {
      const y = year;
      let m = month;
      if (m < 10) m = `0${m}`;
      let d = day;
      if (d < 10) d = `0${d}`;
      return `${y}-${m}-${d}`;
    },
  },
};
</script>

<style lang="scss">
.mian {
  width: 100vw;
  margin-bottom: 15px;
  /* background: #000000; */
}
.cellBorder {
  width: 100%;
  height: 2px;
  background-color: rgba(228, 226, 226, 0.76);
}
.weekdays {
  display: flex;
  font-size: 16px;
  color: rgba(58, 57, 57, 0.788);
  margin: 10px 0;
  li {
    flex: 1;
    text-align: center;
  }
}
.days {
  display: flex;
  margin: 10px 0;
  align-items: center;
  font-size: 16px;
  li {
    flex: 1;
    font-size: px2rem(30);
    text-align: center;
    margin-top: px2rem(10);
    line-height: px2rem(60);
    .active {
      display: inline-block;
      width: 100%;
      height: 20px;
	  line-height: 20px;
      color: #fff;
      border-radius: 6px;
      background-color: rgb(74, 194, 184);
    }
    .other-month {
      color: #e4393c;
    }
  }
}

.duty {
  background-color: rgba(228, 226, 226, 0.76);
  border: 1px solid white;
}
.dutyIcon {
  margin-top: 10px;
  background-color: white;
  // border: 1px solid red;
}
.timeImg {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.doctor {
  display: flex;
  padding-top: 10px;
}
.doctorIcon {
  display: flex;
  flex-direction: column;
}
.doctorName {
  margin-right: 10px;
  font-size: 16px;
}
.doctorImg {
  margin: 0px 10px 10px 10px;
  width: 70px;
  height: 70px;
}
.doctorTitlt {
  font-size: 10px;
  color: rgb(243, 88, 88);
  border: 1px solid rgb(243, 88, 88);
  padding: 2px;
}
.timeIcon {
  display: flex;
  margin-top: 10px;
}
.icon {
  display: flex;
  margin-top: 10px;
  padding-bottom: 10px;
}
.icon-text {
  background-color: #ff832a;
  color: white;
  margin-left: 5px;
  border-radius: 5px;
  padding: 5px;
  font-size: 10px;
}
.separate {
  background-color: #eeeeee;
  height: 1px;
  border: 0px;
}
</style>